import React from "react";

const GradientProgress = ({
  title,
  value = 0,
  min = 0,
  max = 5000,
  minLabel,
  maxLabel,
  valueLabel,
  overMaxLabel,
  preventOverMax = true,
  labelPrefix = "$",
  labelSuffix = "",
  showMinLabel = true,
  showMaxLabel = true,
  showValueLabel = true,
  startColor = "rgba(255, 255, 255, 0)",
  endColor = "#26e3ba",
  backgroundColor = "rgba(255, 255, 255, 0)",
  progressBarHeight = "1.2em",
  containerHeight = "1.2em",
  titleClassName = "pb-1",
  containerClassName = "my-4 mb-6 pb-4",
  containerStyle = { position: "relative" },
  progressBarClassName = "",
  progressBarContainerClassName = "rounded-full shadow-md",
  progressBarContainerStyle = { overflow: "hidden" }, //border: '0.5px solid #80808017'
  minLabelClassName = "",
  maxLabelClassName = "px-1",
  minMaxLabelsClassName = "text-xs text-gray-600 pt-1",
  valueLabelClassName = "text-xs text-white font-bold top-0 pr-2"
}) => {
  const minL = minLabel || `${labelPrefix}${min}`;
  const maxL = maxLabel || `${labelPrefix}${max}`;
  const valL =
    (value > max ? overMaxLabel : null) ||
    valueLabel ||
    `${labelPrefix}${value}${labelSuffix}`;
  const progressBarWidthPercentage = preventOverMax
    ? Math.min((value / max) * 100, 100)
    : (value / max) * 100;
  return (
    <div style={containerStyle} className={containerClassName}>
      <div style={{ width: "95%" }} className="m-auto">
        <div className={titleClassName}>
          {title && <span className="font-bold">{title}</span>}
        </div>
        <div
          className={progressBarContainerClassName}
          style={{
            backgroundColor,
            height: containerHeight,
            position: "relative",
            ...progressBarContainerStyle
          }}
        >
          <div
            className={progressBarClassName}
            style={{
              height: progressBarHeight,
              width: `${progressBarWidthPercentage}%`,
              /* TODO this now ignores startColor, maybe we shouldn't */
              backgroundImage: `linear-gradient(to right, rgba(38,227,186, ${Math.max(
                0,
                (20 - progressBarWidthPercentage) / 20
              )}), ${endColor})`,
              transition: "width 0.5s",
              position: "relative"
            }}
          >
            {showValueLabel && (
              <div
                style={{
                  position: "absolute",
                  ...(progressBarWidthPercentage >= 10
                    ? { right: 0 }
                    : { left: "5px", color: "black" })
                }}
                className={valueLabelClassName}
              >
                {valL}
              </div>
            )}
          </div>
        </div>
        {showMinLabel && (
          <div
            style={{ position: "absolute" }}
            className={`${minLabelClassName} ${minMaxLabelsClassName}`}
          >
            {minL}
          </div>
        )}
        {showMaxLabel && (
          <div
            style={{ position: "absolute", right: 0 }}
            className={`${maxLabelClassName} ${minMaxLabelsClassName}`}
          >
            {maxL}
          </div>
        )}
      </div>
    </div>
  );
};

export default GradientProgress;
